
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/labs/[author]/about",
      function () {
        return require("private-next-pages/labs/[author]/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/labs/[author]/about"])
      });
    }
  